// extracted by mini-css-extract-plugin
export default {"container":"yjqAv","banner":"eqR04","form":"H-MGA","content":"_8v5M9","title":"iiXww","description":"zmFq4","details":"_1Kcyp","skeleton-progress":"sLePm"};